import sorted from "../../assets/design-revamp/sorted-sort.svg";

const SortedIcon = ({ style }) => {
  return (
    <>
      <div>
        <img
          className=""
          src={sorted}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default SortedIcon;
